<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Danh sách lớp học
        label.plus(v-on:click="doItemAdd")
          a(v-on:click="doItemAdd")
            span  Thêm lớp học
        label.title-pc {{lstPC.name}}
        .clearfix
      div.box-table(v-if="!$isMobile()" style="max-height: 385px; overflow-y: scroll;" v-on:scroll.passive='handleScroll')
        clTable(
          :centerColumns="['name', 'grade', 'action']" 
          @onfilterbygrade="filterbygrade" 
          @onfilterbyname="filterbyname" 
          :data='classes' 
          :columns='columns' 
          :inlineFilter='true' 
          :filterGrades="grades"
          v-on:onChannel='doChannel'
          v-on:onMember='doMember'
          v-on:onItemEdit="onItemEdit" 
          v-on:onItemDelete="onItemDelete" 
          v-on:onItemShare="onItemShare" 
          v-on:onApproval="onApproval"
        )
      div.card.box-classes(v-else)
        .row-header
          span.label-header Tên lớp học
          .field-header
            input(@change="filterbynameX($event)" placeholder="Tìm theo tên")
        .row-header
          span.label-header Khối lớp
          .field-header
            select(@change="filterbygradeX($event)")
              option( value='') Tất cả
              option(v-for='o in grades' :value='o.id') {{o.name}}
        div.empty-data(v-if='this.classes.length === 0') 
          span Không tìm thấy dữ liệu

        div.list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='item in classes')
            .row-data
              .row-value.title {{item.name}}
            .row-data
              span.label-header Ảnh
              .row-value
                img.img(:src="require('../../assets/Obee_Logo_140@2x.png')" v-if="item.thumbnail === '' || item.thumbnail === null")
                img.img(:src="item.thumbnail" v-else)
            .row-data
              span.label-header Khối lớp
              .row-value {{item.grade.name}}
            .row-data
              span.label-header SL kênh
              .row-value.link(@click="doChannel(item)") {{item.lstChannel_aggregate.aggregate.count}}
            .row-data
              span.label-header Thành viên
              .row-value.link(@click="doMember(item)") {{item.private_community.pc_users_aggregate.aggregate.count}}
            .row-data
              span.label-header Duyệt yêu cầu tham gia
              .row-value(v-if="!item.private")
                 select(@change="onApprovalChange(item, $event)")
                  option( value='1' :selected="item.type_approval === 1") Thủ công
                  option( value='0' :selected="item.type_approval === 0") Tự động
            .row-data
              span.label-header Ngày cập nhật
              .row-value {{formatDate(item.updated_at)}}
            .row-data
              span.label-header
              .row-value
                small(@click="onItemEdit(item)")
                  img(:src="require('../../assets/images/faces/ic_edit.svg')")
                small(@click="onItemDelete(item)")
                  img(:src="require('../../assets/images/theory/delete-24px.svg')")
                ShareNetwork.share(network="facebook" :url="url(item)" :title="item.name" :description="item.description")
                  img(:src="require('../../assets/images/theory/share-alt.svg')")
                small(v-if="item.private > 0 ")
                  img(:src="require('../../assets/images/theory/lock.svg')")
          
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import clTable from './clTable'
import moment from 'moment'
export default {
  components: {
    clTable
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      classes: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'thumbnail', title: 'Ảnh', type: 'image' },
        { key: 'name', title: 'Tên lớp học' },
        { key: 'grade', title: 'Khối lớp' },
        { key: 'lstChannel_aggregate', title: 'SL kênh', type: 'channel_count' },
        // { key: 'private_community', title: 'Thành viên', type: 'user_count' },
        { key: 'userCount', title: 'Thành viên', type: 'user_count' },
        { key: 'type_approval', title: 'Duyệt yêu <br/>cầu tham gia', type: 'select_approval' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: '', type: 'action' }
      ],
      limit: 10,
      offset: 0,
      lstPC: [],
      grades: [],
      filtername: '',
      filtergrade: 0,
      MdNotification,
      students: 0
    }
  },
  mounted () {
    this.$mycontroller.clearStorage('class_id')
    if (this.$route.params.reload === 1) {
      console.log('reload')
      // this.$apollo.queries.classes.refresh()
      this.onCreated()
    }
  },
  watch: {
    '$route': function(from, to) {
      if (from !== to) {
        // this.$apollo.queries.classes.refresh()
        this.onCreated()
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    url(item) {
      let url = window.location.origin + '/' + this.$router.resolve({name: 'join_classes'}).href + 'join-classes/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(item.private_community.name) + '/' + this.$mycontroller.doSanitizeTitle(item.name) + '-' + item.id + '/yeucauthamgia'
      return seoUrl
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    doChannel(payload) {
      this.$router.push({name: 'channel', query: {id: payload.id}})
    },
    doMember(payload) {
      this.$router.push({name: 'member', query: {id: payload.id}})
    },
    doItemAdd() {
      this.$router.push({name: 'classes_add', query: {id: this.lstPC.id}})
    },
    onItemEdit(payload) {
      this.$mycontroller.saveLocalStorage('class_id', payload.id)
      this.$router.push({name: 'classes_edit', params: {class_id: payload.id}, query: {id: payload.pc_id}})
    },
    onItemShare(payload) {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    onApproval(payload, event) {
      let approval = event.target.options[event.target.options.selectedIndex].value
      try {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_CLASSES_APPROVAL),
          variables: {
            id: payload.id,
            pc_id: payload.pc_id,
            updated_by: this.$store.getters.user,
            type_approval: approval
          },
          update: (store, { data: { update_classes } }) => {
          }
        }).then((data) => {
          this.showNotification('Đã thay đổi yêu cầu duyệt', 'success', 'top', 'right', 7000)
        }).catch((error) => {
          console.error(error)
        })
      } catch (e) {
        console.error(e)
      }
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.classes.length + 10
        this.onCreated()
      }
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.classes.length + 5
        this.onCreated()
      }
    },
    filterbyname(valueName) {
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      // this.$apollo.queries.classes.refetch()
      this.onCreated()
    },
    filterbygrade(valueGrade) {
      this.filtergrade = ''
      if (valueGrade !== '') {
        this.filtergrade = valueGrade
      }
      // this.$apollo.queries.classes.refetch()
      this.onCreated()
    },
    filterbynameX(event) {
      var valueName = event.target.value
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      // this.$apollo.queries.classes.refetch()
      this.onCreated()
    },
    filterbygradeX(event) {
      var valueGrade = event.target.options[event.target.options.selectedIndex].value
      this.filtergrade = ''
      if (valueGrade !== '') {
        this.filtergrade = valueGrade
      }
      // this.$apollo.queries.classes.refetch()
      this.onCreated()
    },
    onItemDelete(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'XOÁ LỚP HỌC',
          text: 'Bạn có chắc muốn xóa lớp học <b>' + payload.name + '</b> này khỏi hệ thống hay không',
          class: 'col-md-6 col-12 box-popup-confirm',
          buttons: [
            {
              title: 'Xác nhận',
              default: true,
              class: 'btn btn-primary confirm-delete-dialog',
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.DELETE_CLASSES),
                  variables: {
                    id: payload.id,
                    pc_id: this.$route.query.id,
                    updated_by: this.$store.getters.user
                  },
                  update: (store, { data: { delete_classes } }) => {
                  }
                }).then((data) => {
                  // this.$apollo.queries.classes.refetch()
                  this.onCreated()
                  this.showNotification('Lớp học ' + payload.name + ' đã bị xóa', 'warning', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy yêu cầu',
              class: 'btn btn-primary cancel-delete-dialog'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    async getMemberTotal(item) {
      // console.log('getMemberTotal: ', item)
      await this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_PC_COUNT_STATUS),
        fetchPolicy: 'no-cache',
        variables: {
          pc_id: item.pc_id,
          classes_id: item.id,
          status: 2
        }
      }).then((res) => {
        // console.log(res)
        if (res.data && res.data.pc_user_aggregate) {
          this.students = res.data.pc_user_aggregate.aggregate.count
        } else {
          this.students = 0
        }
      })
    },
    async onCreated() {
      let variables = {
        pc_id: Number(this.$route.query.id),
        limit: this.limit,
        order_by: {created_at: 'desc'}
      }
      if (this.filtername !== '') {
        variables = Object.assign(variables, {name: '%' + this.filtername + '%'})
      }
      if (this.filtergrade !== '' && this.filtergrade > 0) {
        variables = Object.assign(variables, {grade_id: this.filtergrade})
      }
      let {data} = await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_TO_PC),
        fetchPolicy: 'no-cache',
        variables: variables
      })
      if (data && data.classes && data.classes.length > 0) {
        let lstClasses = data.classes
        for (let i = 0; i < lstClasses.length; i++) {
          await this.getMemberTotal(lstClasses[i])
          lstClasses[i].userCount = this.students
        }
        // console.log('classes: ', lstClasses)
        this.classes = lstClasses
      }
    }
  },
  async created() {
    if (this.$store.getters.user !== null) await this.onCreated()
    this.$mycontroller.clearStorage('class_id')
  },
  apollo: {
    lstPC: {
      query: gql(graphql.GET_PC_OF_USER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            user_id: {_eq: this.$store.getters.user},
            id: {_eq: this.$route.query.id}
          }
        }
      },
      update: data => {
        return data.private_community[0]
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    grades: {
      query: gql(graphql.GET_GRADES),
      fetchPolicy: 'no-cache',
      update: data => {
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .box_header
    label.title{
      text-align: left; 
      font-size:20px;
      font-weight:bold;
      font-family: 'adobe-clean', sans-serif;
      letter-spacing: 0px;
      color: #5F6468;
      display:inline-block
    }
    label.title-pc{display: block;margin-top: 10px;}
    label.plus{
        background: #FFD311 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 12px 40px;
        float:right;
        cursor: pointer;
      }
      label.minus{
        background: #FFD311 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 12px 40px;
        float:left;
        cursor: pointer;
      }
      span{
        font: Regular 14px;
        letter-spacing: 0px;
        color: #23180A;
      }
  .box-table{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #00000029;
    padding:10px;
    margin-top:20px;
    input, select{border-radius: 10px !important;}
  }
  .list-action {
  cursor: pointer;
}
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
.box-classes{
  input, select{border-radius: 10px;}
}

@media screen and (min-width: 768px){
  .vue-dialog {
    width: 500px! important;
  }
}
@media screen and (max-width: 991px){
  .box_header{
    label.title{display: block;}
    label.plus{display: inline-block;float: none;margin-top: 15px;}
    label.title-pc{display: block;}
  }
  .box-classes{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{display: inline-block; line-height: 30px;width: 40%;font-weight: bold;text-align: right; padding-right: 10px;}
      .field-header{padding: 3px 10px; display: inline-block; width: 60%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; border-radius: 10px;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;}
    }
    input, select{border-radius: 10px !important;}
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px; text-align: center; padding: 5px;}
    .list-item{margin-top: 20px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px; padding: 7px 5px;
        &:first-child{margin-bottom: 10px;}
        .row-data{
          .label-header{display: inline-block; width: 40%;font-weight: bold;text-align: left;}
          .row-value{padding: 3px 0; display: inline-block; width: 60%;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            a{margin-right: 10px; float: left;
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .box_header{
    label.title{display: block;}
    label.plus{display: inline-block;float: none;margin-top: 15px;}
    label.title-pc{display: block;}
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?390ee7a3